module.exports = __webpack_public_path__ + "static/media/Darius.d90f224f.png";